import { combineReducers } from 'redux';
//import { IntlReducer as Intl, IntlProvider } from 'react-redux-multilingual'

// Import custom components
import productReducer from './products';
import filtersReducer from './filters';


const rootReducer = combineReducers({
    data: productReducer,
    filters: filtersReducer,
    Intl
});

export default rootReducer;